export const SearchOrgRefinement = {
  AREAS_OF_FOCUS: 'areasOfFocus',
  LOCALE: 'locale',
  ORG_TYPE: 'orgType',
  RADIUS: 'radius',
} as const;

export const SEARCH_ORGS_REFINEMENT_NAMES = Object.values(SearchOrgRefinement);

export type SearchOrgsRefinementType =
  (typeof SearchOrgRefinement)[keyof typeof SearchOrgRefinement];

export const SEARCH_ORGS_REFINEMENT_LABELS = Object.defineProperties(
  {},
  {
    [SearchOrgRefinement.AREAS_OF_FOCUS]: {
      get: () => getText('Cause Areas'),
      enumerable: true,
    },
    [SearchOrgRefinement.LOCALE]: {
      get: () => getText('Listing Language'),
      enumerable: true,
    },
    [SearchOrgRefinement.ORG_TYPE]: {
      get: () => getText('Org Type'),
      enumerable: true,
    },
    [SearchOrgRefinement.RADIUS]: {
      get: () => getText('Radius'),
      enumerable: true,
    },
  },
) as Record<SearchOrgsRefinementType, string>;
